import {
    ControlTextSizeContext,
    FieldBorderContext,
    TextDefaultSizeContext,
    TooltipVariantContext,
} from '@amelio/ui-library';

import type { ReactNode } from 'react';

/**
 * What the library assumes when a call site of this module says nothing: the two typography steps
 * the designs draw at, the frame every text and date field wears at rest, and the variant of every
 * tooltip bubble.
 *
 * These are decisions of the whole module, not of a screen, so each one is declared here once and
 * read everywhere -- and undone in one line. A call site that wants otherwise still says so.
 *
 * Every federated entry point mounts its own React tree, so a decision declared in one of them
 * reaches nothing in the others. Mounting this in each entry point is what keeps the module looking
 * the same wherever it is embedded.
 */
export const ModuleDesignDefaultsProvider = ({ children }: { children: ReactNode }) => (
    <TextDefaultSizeContext.Provider value={'small'}>
        <ControlTextSizeContext.Provider value={'sm'}>
            <FieldBorderContext.Provider value={true}>
                <TooltipVariantContext.Provider value={'elevated'}>
                    {children}
                </TooltipVariantContext.Provider>
            </FieldBorderContext.Provider>
        </ControlTextSizeContext.Provider>
    </TextDefaultSizeContext.Provider>
);
